import { FetcherList } from '@garpix/fetcher/fetcher-list/react-router'
import { dataStates } from '@garpix/fetcher'
import { api } from '@/api'
import NewsCard from '@/components/Cards/NewsCard'
import Section from '@/components/Section'
import Title from '@/components/Title'
import { usePage } from '@/hooks'
import { News } from '@/interfaces/News'
import React from 'react'
import style from '../styles/news_details.module.scss'
import { IFetcherListResults } from '@/interfaces/Fetcher'
import Button from '@/components/Button'
import BlockSpinner from '@/components/Spinner/BlockSpinner'

const MoreNews = (): React.ReactElement => {
  const page = usePage()
  const { config } = page.init_state.global

  return (
    <FetcherList
      initFilter={{ page_size: 4 }}
      isScrollTop={false}
      isHistoryPush={false}
      api={api.getNewsList}
    >
      {({ results, status, showMore, isNext }: IFetcherListResults<News[]>) => {
        return (
          <Section>
            <Title type='h2' theme='h1' className={style.detail__title}>
              Еще новости
            </Title>
            <div className={style.more}>
              {results.map((el) => {
                return (
                  <NewsCard
                    key={el.id}
                    title={el.name}
                    text={el.preview_text}
                    date={el.active_from}
                    image={el.preview_picture?.[0]}
                    url={`${config.news_detail}?element_id=${el.id}`}
                  />
                )
              })}
            </div>
            {status === dataStates.loading ? <BlockSpinner /> : null}
            {isNext
              ? (
                <Button
                  disabled={status === dataStates.loading}
                  onClick={showMore}
                  size='large'
                  wide
                  outline
                >
                  Показать еще
                </Button>
                )
              : undefined}
          </Section>
        )
      }}
    </FetcherList>
  )
}

export default MoreNews
